(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("dsb", [], factory);
	else if(typeof exports === 'object')
		exports["dsb"] = factory();
	else
		root["$cbSelectPlusI18n"] = root["$cbSelectPlusI18n"] || {}, root["$cbSelectPlusI18n"]["dsb"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 